import React from 'react';

import { wrapWithStore } from 'helpers/store';
import { useGetPracticeSettings } from 'store/settings/selectors';
import { GenericTitle, TitleMargin } from 'components/GenericTitle/GenericTitle';
import LandingApp from 'LandingApp';

import { LoginForm } from '../components/LoginForm/LoginForm';
import { Column, Grid, PageContents } from '../styled';

export interface Props {
  successMessage?: string;
}

function LoginPage({ successMessage }: Props) {
  const { tradingName } = useGetPracticeSettings();

  return (
    <LandingApp>
      <PageContents>
        <GenericTitle marginBottom={TitleMargin.Lg}>{tradingName}</GenericTitle>

        <Grid>
          <Column>
            <LoginForm successMessage={successMessage} />
          </Column>
        </Grid>
      </PageContents>
    </LandingApp>
  );
}
export { LoginPage as LoginPageUnwrapped };
export default wrapWithStore(LoginPage);
